<template>
  <div>
    <label class="mb-1" v-html="label" />
    <div class="input-group">
      <div class="input-group-prepend">
        <div v-if="$slots.prepend">
          <slot name="prepend" />
        </div>

        <em v-else-if="icon" :class="icon" />
        <div class="input-group-text bg-primary-1 text-white" v-html="html" />
      </div>
      <input
        v-model="data"
        :aria-label="placeholder"
        class="form-control"
        :placeholder="placeholder"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputGroup',
  props: {
    value: [String, Number],
    html: {
      type: String,
      default: () => '$',
    },
    icon: {
      type: String,
      default: () => null,
    },
    type: {
      type: String,
      default: () => 'text',
    },
    placeholder: String,
    label: String,
  },
  data() {
    return {
      data: this.value,
    };
  },
};
</script>
